import { loadedNameSpaces } from './loadedNameSpaces';

import type { NameSpace } from './locales.types';

export const nameSpaceNames = Object.keys(loadedNameSpaces) as NameSpace[];
